export enum ProductCustomForms{
    IntelligyReady = 'intelligy-ready',
    HasIntelligy = 'has-intelligy',
    PhysicalMeteringPoints = 'physical-meteringpoints',
    UseMeteringPoints = 'use-meteringpoints',
    UseHotMeteringPoints = 'use-hot-meteringpoints',
    UseColdMeteringPoints = 'use-cold-meteringpoints'
}